'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// styled


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WebformElement = require('../WebformElement');

var _WebformElement2 = _interopRequireDefault(_WebformElement);

var _wrapper = require('./styled/wrapper');

var _wrapper2 = _interopRequireDefault(_wrapper);

var _range = require('./styled/range');

var _range2 = _interopRequireDefault(_range);

var _rangeValueWrapper = require('./styled/range-value-wrapper');

var _rangeValueWrapper2 = _interopRequireDefault(_rangeValueWrapper);

var _rangeValue = require('./styled/range-value');

var _rangeValue2 = _interopRequireDefault(_rangeValue);

var _validationIcon = require('./styled/validation-icon');

var _validationIcon2 = _interopRequireDefault(_validationIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RangeField = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RangeField, _Component);

  function RangeField() {
    (0, _classCallCheck3.default)(this, RangeField);
    return (0, _possibleConstructorReturn3.default)(this, (RangeField.__proto__ || (0, _getPrototypeOf2.default)(RangeField)).apply(this, arguments));
  }

  (0, _createClass3.default)(RangeField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // rewrite to 0 if not numeric
      var value = !isNaN(parseFloat(this.props.value)) && isFinite(this.props.value) ? this.props.value : 0;
      this.props.onChange(value);
    }
  }, {
    key: 'getLabelPosition',
    value: function getLabelPosition() {
      return this.props.field['#title_display'];
    }
  }, {
    key: 'getPercentageValue',
    value: function getPercentageValue() {
      var minValue = parseFloat(this.props.field['#min']);
      var range = parseFloat(this.props.field['#max']) - minValue;
      var rangeValue = (this.props.value - minValue) / range;
      rangeValue = isFinite(rangeValue) ? rangeValue : 0;
      rangeValue = rangeValue > 0 ? rangeValue : 0;

      return rangeValue * 100;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _wrapper2.default,
          { labelDisplay: this.getLabelPosition() },
          _react2.default.createElement(_range2.default, (0, _extends3.default)({}, this.props, {
            type: 'range'
          })),
          _react2.default.createElement(
            _rangeValueWrapper2.default,
            { labelDisplay: this.getLabelPosition() },
            _react2.default.createElement(
              _rangeValue2.default,
              { style: { left: this.getPercentageValue() + '%' } },
              this.props.value
            )
          ),
          _react2.default.createElement(_validationIcon2.default, { success: this.props.webformElement.isSuccess(), className: 'hrw-validation-icon' })
        )
      );
    }
  }]);
  return RangeField;
}(_react.Component), _class.propTypes = {
  field: _propTypes2.default.shape({
    '#title_display': _propTypes2.default.string,
    '#min': _propTypes2.default.string,
    '#max': _propTypes2.default.string
  }).isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]).isRequired,
  onChange: _propTypes2.default.func.isRequired,
  webformElement: _propTypes2.default.instanceOf(_WebformElement2.default).isRequired
}, _temp);
exports.default = RangeField;